module.exports = __webpack_public_path__ + "img/iconfinder_359_Viber_logo_4375169.b3a2cc1c.png";